import React from 'react';
import PropTypes from 'prop-types';

import {DateTimePicker} from '@mui/x-date-pickers';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';

const DateTimePickerFull = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DateTimePicker
        {...props}
        allowSameDateSelection
        slotProps={{
          textField: {
            ...props.textFieldProps,
          },
        }}
      />
    </LocalizationProvider>
  );
};

DateTimePickerFull.propTypes = {
  locale: PropTypes.string,
  textFieldProps: PropTypes.object,
};

export default React.memo(DateTimePickerFull);
